import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { apiClient } from "@/config/api";
import {
  CreateSupportTicketBody,
  GetSupportTicketsBody,
} from "@/api/support/types";

export const createSupportTicket = createAsyncThunk(
  "/support/tickets/create",
  async (
    { name, message, files }: CreateSupportTicketBody,
    { rejectWithValue }
  ) => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("message", message);
      formData.append("type", "Other");
      if (files.length > 0) {
        for (const file of files) {
          formData.append("attachments", file);
        }
      }
      const response = await apiClient.post("/support-tickets", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message || "Create support ticket failed"
        );
      }
      return rejectWithValue("Create support ticket failed");
    }
  }
);

export const getSupportTickets = createAsyncThunk(
  "/support/tickets/get",
  async ({ page }: GetSupportTicketsBody, { rejectWithValue }) => {
    try {
      const response = await apiClient.get("/support-tickets", {
        params: {
          page,
        },
      });
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message || "Get support tickets failed"
        );
      }
      return rejectWithValue("Get support tickets failed");
    }
  }
);
